import React from 'react';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as LinkIcon } from 'assets/img/icons/external-link.svg';

export default function AddButton({
  href = '',
  title = '',
  size = 'lg',
  loading = false,
  disabled = false,
  customType = 'primary',
  onClick = () => {},
  children = null
}) {
  const onButtonClick = () => {
    if (href) {
      window.open(href, '_blank');
    }
    onClick();
  };

  return (
    <UiKit.Button
      size={size}
      variant={customType}
      onClick={onButtonClick}
      disabled={disabled}
      processing={loading}
    >
      {children || title}
      {href && <LinkIcon className={styles.icon} />}
    </UiKit.Button>
  );
}
